import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.475 2.6C1.475 1.97868 1.97868 1.475 2.6 1.475H9.8C10.4213 1.475 10.925 1.97868 10.925 2.6V9.8C10.925 10.4213 10.4213 10.925 9.8 10.925H2.6C1.97868 10.925 1.475 10.4213 1.475 9.8V2.6ZM2.6 0.125C1.2331 0.125 0.125 1.2331 0.125 2.6V9.8C0.125 11.1669 1.2331 12.275 2.6 12.275H3.725V13.4C3.725 14.7628 4.83721 15.875 6.2 15.875H13.4C14.7628 15.875 15.875 14.7628 15.875 13.4V6.2C15.875 4.83721 14.7628 3.725 13.4 3.725H12.275V2.6C12.275 1.2331 11.1669 0.125 9.8 0.125H2.6ZM12.275 5.075V9.8C12.275 11.1669 11.1669 12.275 9.8 12.275H5.075V13.4C5.075 14.0172 5.58279 14.525 6.2 14.525H13.4C14.0172 14.525 14.525 14.0172 14.525 13.4V6.2C14.525 5.58279 14.0172 5.075 13.4 5.075H12.275Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }